module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/casestudy-img-03-8f15a488fdac737a277585a9f14a1260.png";